import { colors } from '@sweep-io/sweep-design';

export const ACTIVE_COLOR = colors.blue[100];
export const HOVER_COLOR = colors.grey[100];
